<div class="d-flex mx-0 flex-column flex-md-row justify-contet-between p-white border-bottom secondaryMenu px-4 py-3">
    <div class="d-flex flex-column col">
        <h3 class="mt-0 mb-1">All Templates</h3>
        <p-breadcrumb [model]="items"></p-breadcrumb>
    </div>
    <div class="d-flex justify-content-start justify-content-md-end col mt-2 mt-md-0">
        <button pButton type="button" icon="pi pi-plus" label="Add Template" iconPos="left" routerLink="/createTemplate"></button>
    </div>
</div>

<div class="p-white shadow m-3">
<p-table [value]="products" responsiveLayout="scroll" [autoLayout]="true" styleClass="p-datatable-striped">
    <ng-template pTemplate="caption">
        <div class="d-flex flex-row justify-content-between">
            <span class="p-input-icon-left p-ml-auto">
                <i class="pi pi-search"></i>
                <input pInputText type="text"  placeholder="Search keyword" />
            </span>
            <button pButton label="Clear" class="p-button-outlined" icon="pi pi-filter-slash"></button>
        </div>
    </ng-template>
    <ng-template pTemplate="header">
        <tr>
            <th  pSortableColumn="code">Template Name<p-sortIcon field="code"></p-sortIcon></th>
            <!-- <th  pSortableColumn="model">Vehicle model<p-sortIcon field="code"></p-sortIcon></th>
            <th  pSortableColumn="driver">Driver Name<p-sortIcon field="code"></p-sortIcon></th> -->
            <th>Department <p-columnFilter type="text" field="CreatedOn" display="menu"></p-columnFilter></th>
            <th>Section <p-columnFilter type="text" field="CreatedOn" display="menu"></p-columnFilter></th>
            <th>Job Type <p-columnFilter type="text" field="CreatedOn" display="menu"></p-columnFilter></th>
            <th>Job Category<p-columnFilter type="text" field="CreatedOn" display="menu"></p-columnFilter></th>
            <th>Budget Type</th>
            <th>Priority</th>
            <th>Created On <p-columnFilter type="date" field="CreatedOn" display="menu"></p-columnFilter></th>
            <th>Created By<p-columnFilter type="text" field="CreatedBy" display="menu"></p-columnFilter> </th>
            <th></th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-product>
        <tr>
            <td>Purchase reqest</td>
            <td>Marketing</td>
            <td>Magazine</td>
            <td>Advertising</td>
            <td>Magazine Advertising</td>
            <td>N/A</td>
            <td>High</td>
            <td>Admin User</td>
            <td>2020 July 12</td>
            <td>
                <!-- <button pButton pRipple type="button" icon="pi pi-check" class="p-button-text"></button> -->
                <button pButton pRipple type="button" icon="pi pi-pencil" class="p-button-success p-button-text"></button>
                <button pButton pRipple type="button" icon="pi pi-trash" class="p-button-danger p-button-text"></button>
            </td>
        </tr>
    </ng-template>
</p-table>
<div class="d-flex justify-content-end">
           
    <p-paginator [rows]="10" [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [rowsPerPageOptions]="[10,20,30]"></p-paginator>
</div>
</div>


